import { ComplaintV1Status } from "./complaint-v1-statuses";

export const complaintV1ListColumns = [
    'created',
    'orderDocumentNumber',
    'documentNumber',
    'requester',
    'status',
] as const;
export type ComplaintV1ColumnKey = typeof complaintV1ListColumns[number];

export type ComplaintV1ColumnSortOrder = {
    column: ComplaintV1ColumnKey;
    order: 'asc' | 'desc' | null;
}[];

export interface ComplaintV1Filters {
    documentNumber:string;
    orderDocumentNumber:string;
    status: ComplaintV1Status;
    contractorCompanyName: string;
}

export interface ComplaintV1RequestParams {
    userId: number;
    appVersion: string;
    sort: ComplaintV1ColumnSortOrder;
    filters: ComplaintV1Filters;
    offset: number;
    limit: number;
};